<template>
    <div>
        <div >
        <!-- <h1>{{$t('userInfo.name')}}</h1> -->
        <!--顶部导航-->
        <navgate></navgate>
        <!--内容区域-->
        <div class="web_box">
            <div class="web_content">
                <div class="layout_box">
                    <RowSlider selectedKey="partyBuild" parentRouteKey="partyBuild"></RowSlider>
                    <div class="layout_right">
                        <ImageTitleListView titleName="党建引领" :messageList="newsList.list" :perPage="perPage" detailRouter="partyDetail"></ImageTitleListView>
                    </div>
                </div>
            </div>
            <!--联系我们-->
            <footer-build></footer-build>
        </div>
        
        
        
        </div>
        <!--<button @click="changLang">ccccc</button>-->
        <router-view/>
    </div>
    
</template>

<script>
import RowSlider from './childSlider/RowSlider'
import HttpUtils from "../../util/HttpUtils";
import ImageTitleListView from './container/ImageTitleListView'

export default {
  name: 'Introduce',
  components:{RowSlider,ImageTitleListView},
  props: {
    
  },
  data(){
    return{
      newsList:{total:0,perPage:1,list:[]},
      perPage:1,
    }
  },
  methods:{
    loadNewsData(){
      // this.newsList = require('../../store/json/partyBuild.json')
      // this.perPage = this.newsList.perPage;
      let that = this;
      new HttpUtils().sendGet(that, '/foundation_api/partyBuild.json',  { }, function (sucess, res) {
        that.newsList = res
        that.perPage = that.newsList.perPage;
      });
    },
    secondItemClick(pageName){
      this.$router.push(pageName)
    },
    changLang(){
      const lang = this.$i18n.locale //获取当前页面默认使用的语言
      console.log(lang)  //控制台输出 'zh'
      // 实现中英切换
      if(lang == 'zh'){ //如果默认是中文，在用户点击时就切换到英文状态
          this.$i18n.locale = 'en'
      }else {
          this.$i18n.locale = 'zh'
      }
    }
  },
  mounted(){
    
    this.loadNewsData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../assets/css/ks_foundation.less';
    @import '../../assets/css/ks_media.less';
    @import '../../assets/fonts/iconfont.css';
</style>
